import React from 'react';

import { FilterState } from 'contexts/filtersContext';

import { IconAdjustments } from '@tabler/icons-react';

import { SFilterActive } from './styles';

type FilterIconProps = {
	isLessThan833: boolean;
	filters: FilterState;
};

const FilterIcon = ({ filters, isLessThan833 }: FilterIconProps) => {
	return (
		<React.Fragment>
			<IconAdjustments size={16} />
			{(filters.categories?.length > 0 ||
				filters.markets?.length > 0 ||
				filters.tags?.length > 0) && (
				<SFilterActive isLessThan833={isLessThan833} />
			)}
		</React.Fragment>
	);
};

export default FilterIcon;
